import * as React from 'react';
import { IconClose16 } from '@cian/ui-kit/icons';
import * as styles from './style.css';

interface IFloorPlanHeaderProps {
  onClose(): void;
}

export const FloorPlanHeader = ({ onClose }: IFloorPlanHeaderProps) => {
  return (
    <div className={styles['close']}>
      <button type="button" onClick={onClose} className={styles['close-button']} aria-label="Закрыть">
        <IconClose16 />
      </button>
    </div>
  );
};
